import { ref, uploadBytes, getDownloadURL, listAll } from "firebase/storage";
import { storage } from "@/firebase/config";

/**
 * Test Firebase Storage connection and permissions
 * @returns Promise<boolean> - True if storage is working correctly
 */
export const testFirebaseStorage = async (): Promise<boolean> => {
  try {
    console.log("🧪 Testing Firebase Storage connection...");

    // Create a test reference
    const testRef = ref(storage, "test/connection-test.txt");

    // Upload a small test file
    const testContent = `Test file created at ${new Date().toISOString()}`;
    const testBlob = new Blob([testContent], { type: "text/plain" });

    await uploadBytes(testRef, testBlob);
    console.log("✅ Test file uploaded successfully");

    // Get download URL
    const downloadURL = await getDownloadURL(testRef);
    console.log("✅ Download URL retrieved:", downloadURL);

    return true;
  } catch (error) {
    console.error("❌ Firebase Storage test failed:", error);
    return false;
  }
};

/**
 * Get storage usage statistics
 * @returns Promise<object> - Storage usage information
 */
export const getStorageStats = async (): Promise<{
  newsletterImages: number;
  totalImages: number;
}> => {
  try {
    const newsletterRef = ref(storage, "newsletter-images");
    const newsletterList = await listAll(newsletterRef);

    // You could extend this to count other folders too
    return {
      newsletterImages: newsletterList.items.length,
      totalImages: newsletterList.items.length,
    };
  } catch (error) {
    console.error("Error getting storage stats:", error);
    return {
      newsletterImages: 0,
      totalImages: 0,
    };
  }
};

/**
 * Clean up test files (optional utility)
 * @returns Promise<void>
 */
export const cleanupTestFiles = async (): Promise<void> => {
  try {
    const testRef = ref(storage, "test");
    const testList = await listAll(testRef);

    // Delete test files (you might want to implement this)
    console.log(`Found ${testList.items.length} test files to clean up`);
  } catch (error) {
    console.error("Error cleaning up test files:", error);
  }
};
